export const goodsDescribe = [
  {
    key: 'text',
    label: '文字信息',
  },
  {
    key: 'image',
    label: '图片信息',
  },
];

export const goodsType = [
  {
    value: 'tencent',
    label: '腾讯周边',
  },
  {
    value: 'tongtu',
    label: '通途周边',
  },
];

export const goodsTypeEunm = {
  tencent: '腾讯周边',
  tongtu: '通途周边',
};

export const goodsKind = [
  {
    value: 'entity',
    label: '实体',
  },
  {
    value: 'virtual',
    label: '虚拟',
  },
];

export const goodsKindEunm = {
  entity: '实体',
  virtual: '虚拟',
};

export const changeType = [
  {
    value: '+',
    label: '增加',
  },
  {
    value: '-',
    label: '减少',
  },
];

export const labelCol = {
  xs: {
    span: 24,
  },
  sm: {
    span: 24,
  },
  md: {
    span: 3,
  },
  lg: {
    span: 2,
  },
  xl: {
    span: 2,
  },
  xxl: {
    span: 2,
  },
};

export const wrapperCol = {
  xs: {
    span: 24,
  },
  sm: {
    span: 24,
  },
  md: {
    span: 21,
  },
  lg: {
    span: 22,
  },
  xl: {
    span: 22,
  },
  xxl: {
    span: 22,
  },
};

export const orderStatusOptions = [
  {
    value: 'waiting',
    label: '待发货',
  },
  {
    value: 'delivered',
    label: '已发货',
  },
  {
    value: 'processing',
    label: '订单处理中',
  },
  {
    value: 'cancelled',
    label: '订单已取消',
  },
  {
    value: 'fail',
    label: '交易失败',
  },
];

export const paginationItem = {
  pageSizeOptions: ['10', '20', '30', '40'],
  showQuickJumper: true,
  showSizeChanger: true,
};
